<template>
  <div class="upload-card ma-1">
    <v-row no-gutters>
      <v-col cols="2">
        <div class="image-layout">
          <v-img class="image" src="@/assets/images/dcm.png"></v-img>
        </div>
      </v-col>
      <v-col cols="10" class="px-2">
        <v-row no-gutters>
          <v-col cols="12" class="filename">{{ filename }}</v-col>
          <v-col cols="12" class="loading">
            <v-progress-linear
              :value="progress"
              buffer-value="0"
              stream
            ></v-progress-linear>
          </v-col>
          <v-col cols="12" class="details" v-if="size > 0">
            {{ size | FileSize }}
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    filename: {
      type: String,
      default: 'unknow'
    },
    progress: {
      type: Number,
      default: 0
    },
    size: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-card {
  // background: pink;
  //   margin: 1px;
  //   border: solid 1px grey;
  min-height: 50px;
  padding: 3px;
}

.upload-card .image-layout {
  // background: yellow;
  width: 100%;
  height: 100%;
  position: relative;

  .image {
    // width: 80%;
    height: auto;
    // background: red;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.filename {
  width: 100%;
  height: 100%;
  overflow: hidden;
  font-weight: 400;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-height: normal;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.details {
  width: 100%;
  height: 100%;
  overflow: hidden;
  font-weight: 200;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-height: normal;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
</style>
